import { clientBase } from "../common";

export const getItems = () => {
  return clientBase(`v2/userId?proyect_id=${process.env.VUE_APP_PROYECT_ID}`, "GET");
};